

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('squid/index');

require('components/xo-beaver/dist/logger');

require('components/xo-return-to-merchant/dist/util');

require('components/xo-models/src/checkout/index');

var _icFallback = require('./icFallback');

var _integration = require('./integration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function ($q, $config, $meta, $timeout, $window, $logger, $log, $feature, $ReturnToMerchant, $locale, $util, $FallbackError, $state, $rootScope, $populate, $CheckoutCartModel, $CheckoutAppDataModel, $pxp, $experiment) {
    return function (err) {
        var reason = err.reason;
        var product = err.product;
        var entry_point = err.entryPoint;
        var params = err.params;
        var model = {};

        function getFallbackUrl(urlParams, waType) {
            if ($rootScope.wps || $rootScope.invoice) {
                return $populate(model, {
                    checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
                }).then(function () {
                    // defaulting for now to ensure backward compatibility
                    var base = $config.urls.fallbackUrl['buyNow'];
                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
                        base = $config.urls.fallbackUrl['cartUpload'];
                    }

                    if (model.checkoutAppData.flags.is_invoice_flow) {
                        urlParams.id = model.checkoutAppData.invoice_id;
                        base = $config.urls.fallbackUrl['invoice'];
                    }

                    return $util.paypalURL(base, urlParams);
                });
            } else {
                return $q.when().then(function () {
                    var base = $config.urls.fallbackUrl[product];
                    return $util.paypalURL(base, urlParams);
                });
            }
        }

        function showGenericErrorPage(errorReason) {
            if ($rootScope.partnerIntegration) {
                $logger.info('partner_integration_fallback_to_genericErrorPage');
            }

            var code = errorReason || reason;
            code = code ? window.btoa(code) : code;

            $state.go('checkout.genericError', {
                code: code
            });
        }

        function doFallback() {
            $util.assert(reason, 'expected fallback reason');

            product = product || 'ux';

            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                token: $meta.token,
                fallback: 1,
                reason: reason,
                landing: entry_point,
                useraction: $CheckoutAppDataModel.instance($rootScope.token).useraction()
            });

            if ($rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if ($rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var wpsParams = void 0;
            if ($rootScope.wps) {
                wpsParams = $util.decodeAndParse($meta.xclickParams);
                $logger.info('wps_fallback', {
                    token: $meta.token,
                    reason: reason
                });
                $logger.info('wps_fallback_reason_' + reason, {
                    reason: reason
                });
            }

            var waType = wpsParams && wpsParams.wa_type;

            return getFallbackUrl(urlParams, waType).then(function (url) {
                // Fallback whitelist experiment in config to determine if we should fallback or instead redirect to generic error page.
                // We go to generic error page if the reason is not in the whitelist and random number is below the throttle value
                var fallbackWhitelist = $config.fallbackWhitelist;

                if (fallbackWhitelist && fallbackWhitelist.throttle > 0) {
                    var whitelist = fallbackWhitelist.whitelisted || [];

                    if (whitelist.indexOf(reason) === -1) {
                        if ($util.sessionStorageEnabled() && $experiment('fallback_reason_not_whitelisted', fallbackWhitelist.throttle, $rootScope.token, { reason: reason })) {
                            // we're using sessionStorage for retry detection
                            var RETRY_KEY = 'retry_page_shown';
                            var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                            var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                            var destination = 'RETRY';

                            if (!timesSeen || timesSeen < 0) {
                                // Reset if there's an invalid value for timesSeen for some reason
                                timesSeen = 0;
                            }

                            if (timesSeen < RETRY_PAGE_LIMIT) {
                                // Only try to go to retry page if we're within retry attempts
                                timesSeen++;
                                sessionStorage.setItem(RETRY_KEY, timesSeen);
                            } else {
                                destination = 'DEFAULT';
                            }

                            $logger.info('checkout_fpti', {
                                'enable_refresh_prompt': reason
                            });

                            return showGenericErrorPage(destination);
                        }
                    } else {
                        $logger.info('fallback_reason_whitelisted', {
                            reason: reason,
                            product: product
                        });
                    }
                }

                if (!$config.fallbackEnabled && !entry_point) {
                    return $log.warn('Fallback inhibited by config', url);
                }

                if ($config.deploy.isLocal() && !entry_point) {
                    return $log.warn('Fallback inhibited in local mode.', url);
                }

                $logger.log(product ? 'info' : 'error', 'fallback', {
                    reason: reason,
                    product: product,
                    entry_point: entry_point,
                    error_desc: reason,
                    from: $rootScope.currentState || 'fallback',
                    to: product ? 'process_fallback_' + product : 'process_fallback'
                });

                $logger.info('fallback_reason_' + reason, {
                    reason: reason
                });

                if (window.xchild) {
                    if (window.opener) {
                        return (0, _icFallback.$incontextFallback)(window, url);
                    }

                    return $state.go('checkout.framebust', { action: 'fallback', url: url });
                }

                $rootScope.$emit('loading');

                if (product === 'ux') {
                    // Otherwise we can make a decision based on whether we're in the minibrowser or not
                    return $rootScope.wps && !$rootScope.invoice ? $ReturnToMerchant.postTo(url, wpsParams) : $ReturnToMerchant.goTo(url);
                }

                // Safe to always return to Aries
                return $util.redirect(url);
            });
        }

        if (product === 'error') {
            $logger.error(reason, {
                url: window.location.href
            });

            var _$config$urls = $config.urls,
                baseUrl = _$config$urls.baseUrl,
                errorUrl = _$config$urls.errorUrl;


            return $util.redirect(baseUrl + errorUrl);
        }

        if (_integration.$integration.getConfig('ERROR_AFTER_PAYMENT') && $rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            $logger.info('wps_error_after_payment', {
                reason: reason
            });

            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
        }

        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        var isBeamIntegration = $meta.baToken && beamPattern.test($meta.baToken);
        var cartExchangeFailed = isBeamIntegration && beamPattern.test($meta.token);
        if (cartExchangeFailed) {
            product = 'ux';
        }

        // For Beam Integration - always show generic Error when cart exchange fails.
        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
            return showGenericErrorPage();
        }

        return $populate(model, {
            checkoutCart: $CheckoutCartModel.instance($meta.token),
            checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
        }).then(function () {
            // No fallback for Tokenized_Wallet usecases
            if (model.checkoutCart.isWalletTokenization()) {
                return showGenericErrorPage();
            }
            // V.zero always fallback (no longer controlled by PXP)
            if (product === 'ux' && $rootScope.partnerIntegration) {
                $logger.info('partner_integration_fallback_to_UX');
                $window.resizeTo(screen.availWidth, screen.availHeight);
                return doFallback();
            }
            // Others - Do not fallback if appdata flag dictates no fallback
            if (model.checkoutAppData.flags.disable_legacy_fallback) {
                $logger.error('fallback_inhibited_for_xo_order_tokens');
                return showGenericErrorPage();
            } else {
                return doFallback();
            }
        });
    };
});

_icFallback.$incontextFallback;

_integration.$integration;


//////////////////
// WEBPACK FOOTER
// ./js/lib/fallback.js
// module id = ./js/lib/fallback.js
// module chunks = 1